export default class Channel {
  constructor() {
    this.applicationConfigId = null;
    this.channelIdPattern = null;
    this.priority = 1;
    this.connectionStatsInterval = 12000; // Two minutes by as default.
    this.bandwidthAdaptationPolicy = "Enabled";
    this.codec = {
      opus: {
        bitrate: null,
        disabled: false
      },
      pcmu: {
        disabled: false
      },
      pcma: {
        disabled: false
      },
      g722: {
        disabled: false
      },
      vp8: {
        bitrate: null,
        disabled: false
      },
      vp9: {
        bitrate: null,
        disabled: false
      },
      h264: {
        bitrate: null,
        disabled: false
      }
    };
    this.sfu = {
      audioInput: { maxBitrate: null },
      videoInput: { maxBitrate: null},
      videoOutput: { simulcast: { enabled: false} }
    };
    this.mcu = {
      audioInput: { maxBitrate: null },
      videoInput: { maxBitrate: null },
      audioOutput: { quality: null },
      videoOutput: {
        width: null,
        height: null,
        frameRate: null,
        layoutMargin: null,
        layoutCrop: false
      }
    };
    this.rtmp = {
      enabled: false,
      url: null,
      secretKey: null
    },
    this.recordingEnabled = false;
    this.recordingManagementOverride = {
      muxDisabled: true,
    };
    this.videoEncodings = [];
  }
}
